import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

export const abiResponseService = () => {
    return fetch("/config/abi.json", { headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
  }
  

  export const configResponseService = () => {
    return fetch("/config/config.json", { headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then(response => {
        return response.json();
      })
      .then(json => {
        return json;
      });
  }

  export const  web3ModalConnectService = () => {
    const providerOptions = {
        walletconnect: {
          package: WalletConnectProvider, // required
          options: {
            infuraId: "91c105a5db5a40cdb0099212ba17cb5f", // required
          },
        },
      };

    const web3Modal = new Web3Modal({
        providerOptions,
        cacheProvider: false,
      });

    return new Promise( resolve => {
      resolve(web3Modal.connect());
    });
  }


  export const  web3CoinBaseService = (data) => {
    return new Promise( resolve => {
      resolve(data.web3.eth.getCoinbase());
    });
  }


  export const  web3getChainIdService = (data) => {
    return new Promise( resolve => {
      resolve(data.web3.eth.getChainId());
    });
  }


  export const  providerRequest1 = (data) => {
    return new Promise( resolve => {
      resolve(
        data.provider.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x89" }],
        })
      );
    });
  }

  export const  providerRequest2 = (data) => {
    return new Promise( resolve => {
      resolve(
        data.provider.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: "0x89",
              chainName: "Matic",
              nativeCurrency: {
                name: "Matic",
                symbol: "Matic",
                decimals: 18,
              },
              rpcUrls: ["https://polygon-rpc.com/"],
              blockExplorerUrls: ["https://polygonscan.com"],
            },
          ],
        })
      );
    });
  }